var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pagination',{attrs:{"currentPage":_vm.currentPage,"pageCount":3},on:{"pageSelectionEvent":_vm.handlePageSelection}})}
var staticRenderFns = []

export { render, staticRenderFns }